import { z } from 'zod';

/** Structured error context from a failed filing submission, nested in submissionJson. */
export const submissionErrorContextSchema = z.object({
  category: z.enum([
    'timeout',
    'elementNotFound',
    'network',
    'auth',
    'validation',
    'fileMismatch',
    'infrastructure',
    'unknown',
  ]),
  retryable: z.boolean(),
  step: z.string().optional(),
  stepDisplayName: z.string().optional(),
  district: z.string().optional(),
  pageUrl: z.string().optional(),
  originalError: z.string().optional(),
  originalStack: z.string().optional(),
});

/** Structured error context from a failed filing submission, nested in submissionJson. */
export type SubmissionErrorContext = z.infer<typeof submissionErrorContextSchema>;

/** Schema for the submissionJson shape that contains an error context. */
const submissionJsonWithErrorContextSchema = z.object({
  errorContext: submissionErrorContextSchema,
});

/** Extract a validated SubmissionErrorContext from an unknown submissionJson value, or return null. */
export const parseSubmissionErrorContext = (submissionJson: unknown): SubmissionErrorContext | null => {
  const result = submissionJsonWithErrorContextSchema.safeParse(submissionJson);
  return result.success ? result.data.errorContext : null;
};
